var exports = {
  "K": "CodeElements.module__icon___R0ZHZj",
};

module.exports = exports;
